module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"department":"Abteilung","familyName":"Nachname","givenName":"Vorname","invitationKey":"Einladungsschlüssel","number":"Nummer","tenant":"Mandant","email":"E-Mail"},"en":{"department":"Department","familyName":"Family name","givenName":"Given name","invitationKey":"Invitation key","number":"Number","tenant":"Tenant","email":"Email"}}')
  delete Component.options._Ctor
}
